import BarChart from "Components/Charts/BarChart/BarChart";
import { chartGradientColorsInspectionsSubmissionSummary } from "Containers/Reports/ReportsInnerPages/ReportsInspectionsSubmissionSummary/constants";
import React, { FC } from "react";
import { useIssuesChartsByStatus } from "./useIssuesChartsByStatus";
import styles from "./IssuesChartsByStatus.module.scss";
import { ChartStatusSummary } from "Components/Charts/ChartStatusSummary/ChartStatusSummary";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";

export const IssuesChartsByStatus: FC = () => {
  const { seriesData, xAxisData, loading } = useIssuesChartsByStatus();
  if (loading) return <SkeletonLoader height="410px" />;
  return (
    <section className={styles.wrapper}>
      <div className={styles.barChart}>
        <BarChart
          tooltipValueName="Issues by stats:"
          borderColor="#007DF299"
          color={chartGradientColorsInspectionsSubmissionSummary}
          seriesData={seriesData}
          height="300px"
          xAxisData={xAxisData}
        />
      </div>
      <ChartStatusSummary
        seriesData={seriesData}
        xAxisData={xAxisData}
        colors={chartGradientColorsInspectionsSubmissionSummary}
      />
    </section>
  );
};
